// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxhover {
    position: relative;
    display: inline-block;
    padding: .8em 4em;
    border: 2px solid #333;
    color: #333;
    font-size: 18px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    text-align: center;
    text-decoration: none;
    transition: .3s;
  }
  .boxhover::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    content: '';
    background: #333;
    transition: transform .3s;
  }
  .boxhover:hover {
    color: #fff;
    cursor: pointer;
  }
  .button01::before {
    transform-origin: right top;
    transform: scale(0, 1);
  }
  .button01:hover::before {
    transform-origin: left top;
    transform: scale(1, 1);
  }
  @media screen and (max-width: 850px) {
    .NavbarItems {
      z-index: 99;
    }
    .nav-menu {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background: skyblue;
      width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: -100%;
      opacity: 0;
      align-items: stretch;
      padding: 80px 0 30px 0;
      margin: 0;
      z-index: -1;
      transition: 0.3s ease-in-out;
      border-radius: 13px;
    }
    .nav-menu.active {
      left: 0;
      opacity: 1;
      z-index: -1;
      transition: 0.3s ease-in-out;
    }
    .nav-links {
      text-decoration: none;
      display: block;
      width: 100%;
      font-size: 1.2rem;
      padding: 2rem 0;
    }
    .nav-links:hover {
      text-decoration: none;
      background: #222;
      transition: none;
    }
    button {
      display: none;
    }
    button:hover {
      display: none;
    }
  
    .nav-links-mobile {
      display: block;
      text-align: center;
      padding: 1.5rem;
      margin: auto;
      border-radius: 4px;
      width: 80%;
      background: #01959a;
      text-decoration: none;
      color: #fff;
      font-size: 1.2rem;
      font-weight: 700;
      letter-spacing: 2px;
    }
    .menu-icons {
      display: block;
      cursor: pointer;
    }
    .menu-icons i {
      font-size: 1.2 rem;
      color: #222;
    }
  }
  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px; 
    margin: 0 auto; 
    padding: 0px 10px;
}

.logo img {
    width: 100px; /* Set the width of your logo image */
    height: auto; /* Allow the height to adjust proportionally */
}

.cloudzap-link a {
    text-decoration: none;
    border: 2px solid;
    padding: 10px;
    color: black; /* Change link text color */
    font-weight: bold; /* Add bold font weight if desired */
    font-size: 18px; /* Adjust font size as needed */
}
.cloudzap-link a:hover {
   border:2px solid black;
  background-color: skyblue; 
  color:#ffffff; /* Change link text color */
  font-weight: bold; /* Add bold font weight if desired */
  
}
.centered-box {
    display: flex;
    justify-content: center;
    align-items: center;
    /* Adjust the height to center vertically on the viewport */
}

.report-box {
  padding: 100px;
  width: 1100px;

  border: 2px solid rgb(73, 155, 232);
  border-radius: 4px;
  background-color: #fff;
  background-color: rgb(215, 239, 248);
  text-align: center;
  font-size: 25px;
}

.report-box a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
}

.report-box a:hover {
  color:rgb(39, 177, 231); /* Change link text color on hover */
}
`, "",{"version":3,"sources":["webpack://./src/routes/homepage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE;MACE,WAAW;IACb;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,2BAA2B;MAC3B,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,MAAM;MACN,WAAW;MACX,UAAU;MACV,oBAAoB;MACpB,sBAAsB;MACtB,SAAS;MACT,WAAW;MACX,4BAA4B;MAC5B,mBAAmB;IACrB;IACA;MACE,OAAO;MACP,UAAU;MACV,WAAW;MACX,4BAA4B;IAC9B;IACA;MACE,qBAAqB;MACrB,cAAc;MACd,WAAW;MACX,iBAAiB;MACjB,eAAe;IACjB;IACA;MACE,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;IAClB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,UAAU;MACV,mBAAmB;MACnB,qBAAqB;MACrB,WAAW;MACX,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;IACrB;IACA;MACE,cAAc;MACd,eAAe;IACjB;IACA;MACE,kBAAkB;MAClB,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY,EAAE,qCAAqC;IACnD,YAAY,EAAE,8CAA8C;AAChE;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,YAAY,EAAE,2BAA2B;IACzC,iBAAiB,EAAE,oCAAoC;IACvD,eAAe,EAAE,+BAA+B;AACpD;AACA;GACG,sBAAsB;EACvB,yBAAyB;EACzB,aAAa,EAAE,2BAA2B;EAC1C,iBAAiB,EAAE,oCAAoC;;AAEzD;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;EACE,cAAc;EACd,aAAa;;EAEb,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB,EAAE,oCAAoC;AAC/D","sourcesContent":[".boxhover {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: .8em 4em;\r\n    border: 2px solid #333;\r\n    color: #333;\r\n    font-size: 18px;\r\n    font-family: 'Open Sans', sans-serif;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    transition: .3s;\r\n  }\r\n  .boxhover::before {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: -1;\r\n    content: '';\r\n    background: #333;\r\n    transition: transform .3s;\r\n  }\r\n  .boxhover:hover {\r\n    color: #fff;\r\n    cursor: pointer;\r\n  }\r\n  .button01::before {\r\n    transform-origin: right top;\r\n    transform: scale(0, 1);\r\n  }\r\n  .button01:hover::before {\r\n    transform-origin: left top;\r\n    transform: scale(1, 1);\r\n  }\r\n  @media screen and (max-width: 850px) {\r\n    .NavbarItems {\r\n      z-index: 99;\r\n    }\r\n    .nav-menu {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n      background: skyblue;\r\n      width: 100%;\r\n      height: auto;\r\n      position: absolute;\r\n      top: 0;\r\n      left: -100%;\r\n      opacity: 0;\r\n      align-items: stretch;\r\n      padding: 80px 0 30px 0;\r\n      margin: 0;\r\n      z-index: -1;\r\n      transition: 0.3s ease-in-out;\r\n      border-radius: 13px;\r\n    }\r\n    .nav-menu.active {\r\n      left: 0;\r\n      opacity: 1;\r\n      z-index: -1;\r\n      transition: 0.3s ease-in-out;\r\n    }\r\n    .nav-links {\r\n      text-decoration: none;\r\n      display: block;\r\n      width: 100%;\r\n      font-size: 1.2rem;\r\n      padding: 2rem 0;\r\n    }\r\n    .nav-links:hover {\r\n      text-decoration: none;\r\n      background: #222;\r\n      transition: none;\r\n    }\r\n    button {\r\n      display: none;\r\n    }\r\n    button:hover {\r\n      display: none;\r\n    }\r\n  \r\n    .nav-links-mobile {\r\n      display: block;\r\n      text-align: center;\r\n      padding: 1.5rem;\r\n      margin: auto;\r\n      border-radius: 4px;\r\n      width: 80%;\r\n      background: #01959a;\r\n      text-decoration: none;\r\n      color: #fff;\r\n      font-size: 1.2rem;\r\n      font-weight: 700;\r\n      letter-spacing: 2px;\r\n    }\r\n    .menu-icons {\r\n      display: block;\r\n      cursor: pointer;\r\n    }\r\n    .menu-icons i {\r\n      font-size: 1.2 rem;\r\n      color: #222;\r\n    }\r\n  }\r\n  .navbar {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    max-width: 1200px; \r\n    margin: 0 auto; \r\n    padding: 0px 10px;\r\n}\r\n\r\n.logo img {\r\n    width: 100px; /* Set the width of your logo image */\r\n    height: auto; /* Allow the height to adjust proportionally */\r\n}\r\n\r\n.cloudzap-link a {\r\n    text-decoration: none;\r\n    border: 2px solid;\r\n    padding: 10px;\r\n    color: black; /* Change link text color */\r\n    font-weight: bold; /* Add bold font weight if desired */\r\n    font-size: 18px; /* Adjust font size as needed */\r\n}\r\n.cloudzap-link a:hover {\r\n   border:2px solid black;\r\n  background-color: skyblue; \r\n  color:#ffffff; /* Change link text color */\r\n  font-weight: bold; /* Add bold font weight if desired */\r\n  \r\n}\r\n.centered-box {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* Adjust the height to center vertically on the viewport */\r\n}\r\n\r\n.report-box {\r\n  padding: 100px;\r\n  width: 1100px;\r\n\r\n  border: 2px solid rgb(73, 155, 232);\r\n  border-radius: 4px;\r\n  background-color: #fff;\r\n  background-color: rgb(215, 239, 248);\r\n  text-align: center;\r\n  font-size: 25px;\r\n}\r\n\r\n.report-box a {\r\n  text-decoration: none;\r\n  color: #333;\r\n  font-weight: bold;\r\n}\r\n\r\n.report-box a:hover {\r\n  color:rgb(39, 177, 231); /* Change link text color on hover */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
